<nav class="navbar navbar-expand-lg gradient-background">
    <div class="container-fluid">
        <div>
            <a routerLink="/home" class="navbar-brand link-light text-decoration-none logo-hover ms-1"
                (ctrl-click)="showVersion($event)">
                <span class="fs-4 fw-bold">Crono Configurator</span>
            </a>
            <br>
            <span class="ms-2 small-textsise link-light"> {{ enviromentInfo }} </span><br>
        </div>
        <div class="ms-3" [style.visibility]="showDepartmentSelector() && departments.length > 1 ? 'visible' : 'hidden'">
            <select class="form-select-sm fw-bold" id="dashboard-department"
                (ngModelChange)="onSetDepartmentValue($event)" [(ngModel)]="selectedDropdown"
                [disabled]="this.router.url.indexOf('/customer-dashboard') == 0">
                @for (option of departmentDropdown; track $index)
                {
                <option 
                    [disabled]="option.value === commonService.guidEmpty()" [value]="option.value">
                    {{ option.text }}                
                </option>
                }
            </select>
        </div>
        @if (departments.length == 1)
        {
        <div class="col text-center">
            <!-- <span class="small-textsise link-light"> afdeling: </span>
                <br> -->
            <span class="small-text fw-bold link-light">{{ setDepartmentDropdownText(departments[0]) }}</span>
        </div>
        }

        <div class="collapse navbar-collapse align-items-center justify-content-center" id="navbarSupportedContent">
            <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="mx-2">
                    <a routerLink="/home" class="menu-item nav-link px-1 py-3 link-light">
                        <i class="fas fa-gauge-max"></i> Dashboard
                    </a>
                </li>
                <li class="mx-2">
                    <a routerLink="/customers" class="menu-item nav-link px-1 py-3 link-light"
                        [class.disabled-link]="selectedDepartment.id === commonService.guidEmpty()">
                        <i class="fas fa-users"></i> Kunder
                    </a>
                </li>
                <li class="mx-2">
                    <a routerLink="/templates" class="menu-item nav-link px-1 py-3 link-light"
                        [class.disabled-link]="selectedDepartment.id === commonService.guidEmpty()">
                        <i class="fas fa-right-left"></i> Skabeloner
                    </a>
                </li>
                <li class="mx-2">
                    <a routerLink="/synchronizations" class="menu-item nav-link px-1 py-3 link-light"
                        [class.disabled-link]="selectedDepartment.id === commonService.guidEmpty()">
                        <i class="fas fa-rotate"></i> Synkroniseringer
                    </a>
                </li>
                <li class="mx-2">
                    <a routerLink="/events" class="menu-item nav-link px-1 py-3 link-light"
                        [class.disabled-link]="selectedDepartment.id === commonService.guidEmpty()">
                        <i class="fas fa-calendar-days"></i> Hændelser
                    </a>
                </li>
                <li class="mx-2">
                    <a routerLink="/resourceaccess" class="menu-item nav-link px-1 py-3 link-light"
                        [class.disabled-link]="selectedDepartment.id === commonService.guidEmpty()">
                        <i class="fa-solid fa-user-lock"></i> Adgange
                    </a>
                </li>
                @if (this.store.currentUser.get().isAdmin) {
                <li class="mx-2">
                    <a routerLink="/admin-dashboard" class="menu-item nav-link px-1 py-3 link-light">
                        <i class="fa-kit fa-solid-gauge-max-lock"></i> Admin
                    </a>
                </li>
                }
            </ul>
        </div>
        <button class="navbar-toggler border-0 navbar-toggle-btn" type="button" data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
        <div class="dropdown me-1">
            <a class="d-flex align-items-center link-light text-decoration-none dropdown-toggle" id="dropdownUser"
                data-bs-toggle="dropdown" aria-expanded="false">
                <strong class="logo-hover">{{ this.store.currentUser.get().name }} </strong>
                <div class="circle-text mx-2">{{ getInitials }}</div>
            </a>
            <ul class="dropdown-menu text-small shadow" aria-labelledby="dropdownUser">
                <li>
                    <div class="dropdown-item">{{ enviromentInfo }}</div>
                </li>
                <li>
                    <hr>
                </li>
                <li><a class="dropdown-item" routerLink="/profile"><i class="fas fa-user"></i> Profil</a></li>
                @if (this.store.currentUser.get().isAdmin)
                {
                <li>
                    <hr>
                </li>
                <li><a class="dropdown-item" routerLink="/customer-administration">
                        <i class="fa-regular fa-arrows-to-circle"> </i> Kundeadmin.</a></li>
                <li>
                    <hr>
                </li>
                <li><a class="dropdown-item" routerLink="/db-templates">
                        <i class="fa-regular fa-database"></i> DB skabeloner</a></li>
                <li>
                    <hr>
                </li>
                <li><a class="dropdown-item" routerLink="/translations">
                        <i class="fa-regular fa-book"></i> Sproglag</a>
                </li>
                }
                <li>
                    <hr>
                </li>
                <li><a class="dropdown-item" (click)="logout()">
                        <i class="fas fa-arrow-right-from-bracket"></i> Log ud</a></li>
            </ul>
        </div>
    </div>
</nav>